import { OrderObject } from 'common/types';
import { CallableCreator } from '..';

export const pending = (createCallable: CallableCreator) => ({
	get: createCallable<{ shopId: string; orderId: string }, OrderObject | null>(
		'orders-pending-get',
	),
});
